export default "/solar-savings-calculator";
